const BenefitsSection = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/5519981868997', '_blank');
  };

  return (
    <section className="py-16 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow transform hover:scale-105 duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-24-hours-line text-white text-2xl"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">Atendimento 24 Horas</h3>
            <p className="text-gray-600 text-sm">Disponível todos os dias</p>
          </div>

          <div className="text-center bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow transform hover:scale-105 duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-money-dollar-circle-line text-white text-2xl"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">Melhores Preços</h3>
            <p className="text-gray-600 text-sm">Orçamento competitivo</p>
          </div>

          <div className="text-center bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow transform hover:scale-105 duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-team-line text-white text-2xl"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">Equipe Especializada</h3>
            <p className="text-gray-600 text-sm">Profissionais qualificados</p>
          </div>

          <div className="text-center bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow transform hover:scale-105 duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-timer-flash-line text-white text-2xl"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">Atendimento Rápido</h3>
            <p className="text-gray-600 text-sm">Chegamos em 30 minutos</p>
          </div>
        </div>

        <div className="text-center bg-gradient-to-r from-blue-600 to-green-600 rounded-2xl p-6 sm:p-12 text-white mt-12">
          <h3 className="text-2xl sm:text-3xl font-bold mb-4">
            🚨 Emergência de Desentupimento em Campinas e Região?
          </h3>
          <p className="text-lg sm:text-xl mb-6 max-w-3xl mx-auto">
            <strong>Atendimento 24 horas</strong> para desentupimento urgente! Equipe especializada
            chega em até 30 minutos na sua região com equipamentos profissionais. Orçamento gratuito
            pelo WhatsApp agora!
          </p>
          <button
            onClick={handleWhatsApp}
            className="bg-white text-green-600 hover:bg-gray-100 px-3 py-2 sm:px-4 sm:py-3 rounded-lg font-bold text-xs sm:text-sm transition-all transform hover:scale-105 flex items-center space-x-1 mx-auto whitespace-nowrap cursor-pointer shadow-xl max-w-fit justify-center"
          >
            <i className="ri-whatsapp-line text-sm sm:text-base"></i>
            <span>WhatsApp</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;